import { styled } from '@air/marketing-primitives';

export const Container = styled('div', {
  maxWidth: 1224,
  marginX: 'auto',
  paddingX: 32,
  boxSizing: 'border-box',
});
